import React from 'react'
import type { DocumentBlockProps } from 'components/Cms/Block/Blocks/DocumentBlock/types'
import type { LinkBlockContent } from 'components/Cms/Block/Blocks/LinkBlock/types'
import type { SubcontentBlockProps } from 'components/Cms/Block/Blocks/SubcontentBlock/types'
import type { BlockComponentProps } from 'components/Cms/Block/types'
import { BLOCK_TYPE } from 'pages/Cms/constants'
import Divider from 'redesign/components/atoms/Divider'
import CmsDocumentBlock from 'redesign/components/molecules/blocks/cms-document'
import CmsImageBlock from 'redesign/components/molecules/blocks/cms-image'
import type { ImageDataT } from 'redesign/components/molecules/blocks/cms-image/types'
import CmsSubcontentBlock from 'redesign/components/molecules/blocks/cms-subcontent'
import CmsTextBlock from 'redesign/components/molecules/blocks/cms-text'
import LinkBlock from 'redesign/components/molecules/link-block'
import type { Block } from 'shared/graphql/graphql'
import { BlockContainer } from './styles'

const renderBlock = (block: Block) => {
  if (block.type === BLOCK_TYPE.divider) return <Divider fullWidth fullSize />

  if (!block.data) return <></>

  switch (block.type) {
    case BLOCK_TYPE.document:
      return <CmsDocumentBlock data={block.data as DocumentBlockProps['data']} />

    case BLOCK_TYPE.text:
      return <CmsTextBlock data={block.data} />

    case BLOCK_TYPE.image:
      return <CmsImageBlock data={block.data as ImageDataT} />

    case BLOCK_TYPE.subcontent:
      return <CmsSubcontentBlock data={block.data as SubcontentBlockProps['data']} />

    case BLOCK_TYPE.link:
      return <LinkBlock data={block.data as LinkBlockContent} />

    default:
      return <></>
  }
}

const BlockComponent: React.FC<BlockComponentProps> = ({ block }) => (
  <BlockContainer blockCss={JSON.parse(block.blockCss ?? '{}')}>{renderBlock(block)}</BlockContainer>
)

export default BlockComponent
